import { useMediaQuery, useTheme } from '@mui/material';

export type ScreenMode = {
    isXs: boolean;
    isSm: boolean;
    isMdDown: boolean;
    isLgDown: boolean;
    isShortHeight: boolean;
    isVeryShortHeight: boolean;
    isNarrow: boolean;
    isTabletLike: boolean;
    isCompact: boolean;
    isMobileLike: boolean;
    useCardView: boolean;
};

export default function useScreenMode(): ScreenMode {
    const theme = useTheme();

    const isXs = useMediaQuery(theme.breakpoints.down('sm'));
    const isSm = useMediaQuery(theme.breakpoints.between('sm', 'md'));
    const isMdDown = useMediaQuery(theme.breakpoints.down('md'));
    const isLgDown = useMediaQuery(theme.breakpoints.down('lg'));

    const isShortHeight = useMediaQuery('(max-height: 760px)');
    const isVeryShortHeight = useMediaQuery('(max-height: 680px)');
    const isNarrow = useMediaQuery('(max-width: 900px)');
    const isTabletLike = useMediaQuery('(max-width: 1100px) and (max-height: 900px)');

    const isCompact = isMdDown || isShortHeight || isTabletLike;
    const isMobileLike = isXs || (isNarrow && isShortHeight);
    const useCardView = isMobileLike || isVeryShortHeight;

    return {
        isXs,
        isSm,
        isMdDown,
        isLgDown,
        isShortHeight,
        isVeryShortHeight,
        isNarrow,
        isTabletLike,
        isCompact,
        isMobileLike,
        useCardView,
    };
}